import subscriptionHome from "@/pages/subscription";
import createPackage from "@/pages/subscription/createPackage.vue";
import editPackage from "@/pages/subscription/editPackage.vue";

const routes = [
  { // subscription
    path: 'subscription',
    name: 'subscription',
    component: subscriptionHome,
    meta:{
      name: 'Subscription Configuration',
      requireAuth: true
    },
    props: true
  },
  { // subscription/new
    path: 'subscription/new',
    name: 'new-subscription',
    component: createPackage,
    meta:{
      name: 'Add Subscription',
      requireAuth: true
    },
    props: true
  },
  { // subscription/:id
    path: 'subscription/:id',
    name: 'edit-subscription',
    component: editPackage,
    meta:{
      name: 'Edit Subscription',
      requireAuth: true
    },
    props: true
  },
]

export default routes